<template>
    <div class="data-app">

        <div v-if="loading" class="d-flex justify-content-center ps-5">
            <div 
                class="spinner-border text-secondary" 
                style="width: 3rem; height: 3rem;"
                role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-if="ready" class="data-dashboard">
            <nav 
                class="navbar sticky-top navbar-expand-lg navbar-light rounded-1 border mb-5 py-0"
                style="top: 75px; background: #f7f7f7"
            >
                <div 
                    id="independent-variables" 
                    style="color: #007396"
                    class="mx-4"
                    title="Filter by independent variables"
                >
                    <b>Filter:</b>
                </div>
                <button 
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#factor-menu"
                    aria-controls="factor-menu"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="factor-menu">
                    <ul class="navbar-nav mx-auto">
                        <li class="nav-item"
                            v-for="(label, key) in factorMenu"
                            :key="key">
                            <a class="nav-link"
                                :class="{active: (key == factor)}"                                
                                :href="'#' + key"
                                @click="factor = key">
                                {{ label }}
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>

            <!-- Donut chart -->
            <div v-show="factor != 'all'">
                <distribution-chart
                    :data="data"
                    :factor="factor"
                    :title="factorMenu[factor]" />
                <hr />
            </div>

            <!-- Mobility -->
            <section class="mt-4">
                <h2 class="text-center mb-1">
                    Mobility Index
                </h2>
                <p class="text-center" style="font-style: italic; font-size: 90%; color: #EC773B">
                    A high index score corresponds to a greater degree of mobility
                </p>

                <!-- <div class="row">
                    <div class="col-xl-9">
                        <mobility-chart :data="data" :factor="factor" />
                    </div>
                    <div class="col-xl-3">
                        <mobility-info />
                    </div>
                </div> -->
                
                <mobility-chart :data="data" :factor="factor" />
                <mobility-info />
                
            </section>

            <hr/>

            <!-- Connectivity  -->
            <section class="mt-4">
                <h2 class="text-center mb-1">
                    Connectivity Index
                </h2>
                 <p class="text-center" style="font-style: italic; font-size: 90%; color: #EC773B">
                    A high index score corresponds to a greater degree of connectivity
                </p>
                <connectivity-chart :data="data" :factor="factor" />
                <connectivity-info />
            </section>

            <hr/>

            <!-- Marginalisation -->
            <section class="mt-4">
                <h2 class="text-center mb-1">
                    Marginalisation Index
                </h2>
                 <p class="text-center" style="font-style: italic; font-size: 90%; color: #EC773B">
                    A high index score corresponds to a greater degree of marginalisation
                </p>
                <marginalisation-chart
                    :data="data"
                    :factor="factor" />
                    <marginalisation-info />
            </section>

        </div>
    </div>
</template>

<script>

import axios from 'axios'
import { dsvFormat } from 'd3-dsv'
const HTTP = axios.create({withCredentials: true})

import DistributionChart from './components/DistributionChart.vue'
import MobilityChart from './components/MobilityChart.vue'
import MobilityInfo from './components/MobilityInfo.vue'
import ConnectivityChart from './components/ConnectivityChart.vue'
import ConnectivityInfo from './components/ConnectivityInfo.vue'
import MarginalisationChart from './components/MarginalisationChart.vue'
import MarginalisationInfo from './components/MarginalisationInfo.vue'

export default {
    components: {
        DistributionChart,
        MobilityChart,
        MobilityInfo,
        ConnectivityChart,
        ConnectivityInfo,
        MarginalisationChart,
        MarginalisationInfo,
    },

    data() {
        const factor = document.location.hash.substring(1)
        const factorMenu = {
            'all': 'All',
            "originCountry": "Origin countries",
            'gender': 'Gender',
            'age': 'Age',
            'maritalStatus': 'Marital status',
            'education': 'Education',
            'protectionStatus': 'Protection status',
            "studyCountry": "Countries of study",
            'siteType': 'Site type',
            'IDPCamp': 'In-/Outside of camp',
        }
        return {
            data: null,
            ready: false,
            loading: true,
            factor: (factorMenu[factor]) ? factor : 'all',
            factorMenu: factorMenu,

            // For the collapsible demo:
            isVisible: true
        }
    },
    created() {
        const ver = 1
        const url = APP_DATA_URL + '?v=' + ver
        HTTP.get(url)
            .then(response => {
                this.loading = false
                this.data = dsvFormat(";").parse(response.data)
                this.ready = true
            })
    },
    methods: {
        model() {
            return this.data
        }
    }
}
</script>
